import { FC } from 'react';
import { observer } from 'mobx-react';
import { useDependencies } from '@servicetitan/react-ioc';
import { Divider, Stack } from '@servicetitan/design-system';
import { DetailsItem } from '../details-item/details-item';
import { DetailsSection } from '../details-item/details-section';
import { tenantStatusProps } from '../../utils/tenant-status-props';
import { partitionStatusProps } from '../../utils/partition-status-props';
import { ManagePartitionStore } from '../../stores/manage-partition.store';

export const PartitionSidebar: FC = observer(() => {
    const [{ partnerGenericConfigs, partition, tenantGenericConfigs }] =
        useDependencies(ManagePartitionStore);

    const tenantDetails = partition?.tenantDetails;
    const partnerDetails = tenantDetails?.partnerDetail;

    return (
        <Stack direction="column" className="w-100">
            <DetailsSection title="Tenant Details">
                <Stack direction="column" spacing={2}>
                    <DetailsItem
                        name="Tenant Name"
                        value={tenantDetails?.displayName}
                        textClassName="skeleton-text-50"
                    />
                    <DetailsItem
                        name="Tenant ID"
                        value={tenantDetails?.externalId}
                        textClassName="skeleton-text-33"
                    />
                    <DetailsItem
                        name="Parent Name"
                        value={tenantDetails?.partnerId}
                        textClassName="skeleton-text-50"
                    />
                    <DetailsItem
                        name="Parent ID"
                        value={tenantDetails?.partnerId}
                        textClassName="skeleton-text-33"
                    />
                    <DetailsItem
                        name="Status"
                        value={
                            tenantDetails
                                ? tenantStatusProps[tenantDetails.status].displayName
                                : undefined
                        }
                        textClassName="skeleton-text-33"
                    />
                </Stack>
            </DetailsSection>
            <Divider spacing={3} />
            <DetailsSection title="Partition Details">
                <Stack direction="column" spacing={2}>
                    <DetailsItem
                        name="Partition Name"
                        value={partition?.displayName}
                        textClassName="skeleton-text-50"
                    />
                    <DetailsItem
                        name="Partition ID"
                        value={partition?.externalId}
                        textClassName="skeleton-text-33"
                    />
                    <DetailsItem
                        name="Status"
                        value={
                            partition
                                ? partitionStatusProps[partition.status].displayName
                                : undefined
                        }
                        textClassName="skeleton-text-33"
                    />
                </Stack>
            </DetailsSection>
            <Divider spacing={3} />
            <DetailsSection title="Inherited values from Partner">
                <Stack direction="column" spacing={2}>
                    <DetailsItem
                        name="Email Sender Domain"
                        value={partnerDetails?.configs.emailSenderDomain}
                        textClassName="skeleton-text-75"
                    />
                    <DetailsItem
                        name="Email Scope"
                        value={partnerDetails?.configs.emailScope}
                        textClassName="skeleton-text-50"
                    />
                    <DetailsItem
                        name="Direct Mail Provider"
                        value={partnerDetails?.configs.directMailProvider}
                        textClassName="skeleton-text-50"
                    />
                    <DetailsItem
                        name="Email Template Opt In/Out"
                        value={partnerDetails?.configs.emailTemplateOptOut ? 'Opt Out' : 'Opt In'}
                        textClassName="skeleton-text-50"
                    />
                    {[...partnerGenericConfigs].map(entry => (
                        <DetailsItem
                            key={entry[0]}
                            name={entry[0]}
                            value={entry[1]}
                            textClassName="skeleton-text-75"
                        />
                    ))}
                </Stack>
            </DetailsSection>
            <Divider spacing={3} />
            <DetailsSection title="Inherited values from Tenant">
                <Stack direction="column" spacing={2}>
                    <DetailsItem
                        name="Email Sender Domain"
                        value={tenantDetails?.configs.emailSenderDomain}
                        textClassName="skeleton-text-75"
                    />
                    <DetailsItem
                        name="Email Scope"
                        value={tenantDetails?.configs.emailScope}
                        textClassName="skeleton-text-50"
                    />
                    <DetailsItem
                        name="Direct Mail Provider"
                        value={tenantDetails?.configs.directMailProvider}
                        textClassName="skeleton-text-50"
                    />
                    <DetailsItem
                        name="Email Template Opt In/Out"
                        value={tenantDetails?.configs.emailTemplateOptOut ? 'Opt Out' : 'Opt In'}
                        textClassName="skeleton-text-50"
                    />
                    {[...tenantGenericConfigs].map(entry => (
                        <DetailsItem
                            key={entry[0]}
                            name={entry[0]}
                            value={entry[1]}
                            textClassName="skeleton-text-75"
                        />
                    ))}
                </Stack>
            </DetailsSection>
        </Stack>
    );
});
